const config = {
  app: { 
    port: 3000, 
    link: `${process.env.REACT_APP_API_URL}/`
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    vapId: process.env.REACT_APP_FIREBASE_VAP_ID
  },
  googleapi: {
    client_id: "1048981745632-fa5q5ugtsi0et83hv616d4utp25dk4rr.apps.googleusercontent.com",
    client_secret: "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",
    redirect_url: "https://6357-103-216-212-225.ngrok.io"
  },
  auth: `${process.env.REACT_APP_AUTH_URL}/`,
  sales: process.env.REACT_APP_SALES_URL,
  real_estate: process.env.REACT_APP_REALESTATE_URL,
  help_desk: process.env.REACT_APP_HELP_DESK_URL,
  ticket: process.env.REACT_APP_TICKET_URL,
  store: process.env.REACT_APP_STORE_URL,
  book: process.env.REACT_APP_BOOK_URL,
  inventory: process.env.REACT_APP_INVENTORY_URL,
};
export default config;